import { FC } from 'react';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';

import { setLegalDataProps, LegalDataProps } from '@forms-exp/helpers';
import { Legal } from '@forms-exp/components';

const TermsAndConditions: FC<LegalDataProps> = ({ records }) => {
  return <Legal records={records} />;
};

export const getServerSideProps: GetServerSideProps<LegalDataProps> = async (
  context: GetServerSidePropsContext
) => {
  return await setLegalDataProps(context);
};

export default TermsAndConditions;
